import React, { createContext, useContext, ReactNode } from 'react';
import { 
  convertToUKEnglish, 
  formatUKPrice, 
  ukDateFormat, 
  validateUKPostcode,
  ukCompliance 
} from '@/utils/ukLocalisation';

interface LocaleContextType {
  locale: 'UK' | 'US';
  convertText: (text: string) => string;
  formatPrice: (amount: number, includeVAT?: boolean) => string;
  formatDate: (date: Date) => string;
  validatePostcode: (postcode: string) => boolean;
  compliance: typeof ukCompliance;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

export const LocaleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const contextValue: LocaleContextType = {
    locale: 'UK', // Default to UK
    convertText: convertToUKEnglish,
    formatPrice: formatUKPrice,
    formatDate: ukDateFormat.format,
    validatePostcode: validateUKPostcode,
    compliance: ukCompliance
  };

  return (
    <LocaleContext.Provider value={contextValue}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (context === undefined) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};